import React from 'react';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';

const Rules = () => {
  return (
    <div className="flex flex-col justify-between w-full h-full ">
      <CustomHeader
        title={'قوانین و مقررات'}
        preIcon="icon-nameArrow---Right"
        isActiveRightIcon
      />
      <div className="h-full w-full flex-col overflow-y-auto	">
        <div className="flex w-full justify-center">
          <img
            width={152}
            height={139}
            src="https://my-account.s3.ir-thr-at1.arvanstorage.ir/9719970%201.svg"
            alt=""
          />
        </div>
        <div className="px-3 py-2">
          <p className="lh-lg mt-4 text-break color-gray-1">
            <h4 className="text-md font-Medium">راهنمای خرید امن:</h4>
            <p className="text-sm font-Regular">
              به هیچ‌ وجه مشخصات حساب‌های بانکی خودتان را در اختیار افراد ناشناش
              قرار ندهید.
            </p>
            <p className="text-sm font-Regular">
              ابتدا از هویت و اصالت کالا و متخصصی که قرار است با او معامله کنید
              مطمئن شوید.
            </p>
            <p className="text-sm font-Regular">
              حتما از کسانی خرید کنید که امکان ملاقات حضوری آنها پیش از انجام
              معامله فراهم است.
            </p>
            <p className="text-sm font-Regular">
              در صورت ایجاد مزاحمت برای شما از سمت کاربر و اشخاصی که در سامانه
              حضور پیدا می‌کنند حتما آن کاربر را گزارش دهید یا با پشتیبانی سایت
              تماس بگیرید تا موضوع پیگیری و حل شود.
            </p>
            <p className="text-sm font-Regular">
              در صورت امکان، هنگام خرید کالا رسید کتبی معتبر از فرد فروشنده کالا
              یا خدمت دریافت کنید. حتما در اماکن معتبر و امن همچون نزدیک
              پایگاه‌های پلیس، شعب بانک‌ها و ... قرار ملاقات برای معاملات
              غیررسمی و غیرفروشگاهی بگذارید.
            </p>
            <h4 className="text-md font-Medium">
              بهترین روش برای خرید غیر حضوری:
            </h4>
            <p className="text-sm font-Regular">
              یکی از روش‌های مناسب جهت انجام معامله غیر حضوری استفاده از پست
              (Cash on Delivery) می باشد. در این نوع پست، پستچی کالا را به شما
              تحویل داده و شما پس از بررسی و اطمینان از مطابقت آن با اطلاعاتی که
              فروشنده به شما داده بود می‌توانید مبلغ را به پستچی پرداخت نمایید و
              یا در صورت عدم مطابقت کالا با اظهارات فروشنده و یا وجود خرابی،
              کالا را توسط پستچی مرجوع نمایید.
            </p>
            <h4 className="text-md font-Medium">توصیه مقام محترم قضایی:</h4>
            <h6 className="leading-7 text-sm font-Regular">
              حسب دستور معاون دادستان و سرپرست محترم دادسرا به منظور جلوگیری از
              سوء استفاده جاعلین و کلاهبرداران از طریق چک های رمز دار بین بانکی،
              توجه شما را به متن ارسالی جلب می نماییم:
            </h6>
            <p className="text-sm font-Regular">
              با توجه به اینکه یکی از شگردهای مجرمین و متهمین سابقه دار جهت کسب
              منابع مادی زود هنگام و سریع خرید و فروش ملک و یا اجناس دیگر با
              چک‌های جعلی می‌باشد این افراد سابقه دار با جعل چک‌های بین بانکی
              رمز دار و تماس تلفنی با شهروندان که جهت فروش اجناس خود در شبکه‌های
              اجتماعی یا جراید آگهی فروش منتشر کرده بودند تمایل خود را جهت خرید
              ملک یا کالا اعلام و غالبا در ایام آخر هفته و ساعات پایانی روز در
              محل قرار حاضر شده و با فریب و نیرنگ و معرفی خود بعنوان افراد متشخص
              و حائز شغل و منزلت اجتماعی اقدام به خرید می‌نمایند و در قبال آن یک
              فقره چک بین بانکی رمزدار جعلی ارائه می‌نمایند که تا کنون
              پرونده‌های متعدد در این خصوص تشکیل شده است.
            </p>
            <h4 className="text-md font-Medium">نکات پیش از معامله:</h4>
            <p className="text-sm font-Regular">
              بیعانه ندهید: هرگز پیش از دریافت کالا، هزینه‌ای تحت عنوان بیعانه،
              شیرینی، رزرو و… پرداخت نکنید.
            </p>
            <p className="text-sm font-Regular">
              ذخیره اطلاعات: اطلاعات فروشنده را حتماً ذخیره کنید تا در صورت
              نیاز، دسترسی سریع داشته باشید.
            </p>
            <p className="text-sm font-Regular">
              درخواست فاکتور خرید: در مورد برخی کالاها بهتر است از فروشنده
              بخواهید فاکتور خرید را به همراه داشته باشد.
            </p>
            <p className="text-sm font-Regular">
              پرهیز از مزاحمت: دادن اطلاعات شخصی که نامربوط به معامله است، فقط
              احتمال مزاحمت را بالا می‌برد.
            </p>
            <h4 className="text-md font-Medium">زنگ خطرهای معامله:</h4>
            <ul className="text-sm font-Regular">
              <li>قیمت و شرایط ارائه شده بیش از حد عالی به نظر می رسد.</li>
              <li>
                درخواست بیعانه قبل از دریافت کالا، به هر عنوانی توسط فروشنده
                پیشنهاد شود.
              </li>
              <li>فروشنده اطلاعات شفاف و کاملی درباره کالا ارائه نمی‌کند.</li>
              <li>
                در میانه چت‌کردن در چت فروشگاه ، مخاطب درخواست می‌کند که مکالمه
                در سایر پیام‌رسان‌ها مانند تلگرام و واتس‌اپ و … ادامه پیدا کند.
              </li>
              <li>طرف مقابل بدون دلیل منطقی درخواست معامله حضوری را رد کند.</li>
              <li>
                طرف مقابل بدون دلیل منطقی اطلاعات شخصی یا حساب بانکی شما را
                می‌پرسد.
              </li>
              <li>خریدار بخواهد بدون دیدن کالا، آن را با قیمت عالی بخرد.</li>
            </ul>
            <h4 className="text-md font-Medium">حساب کاربری:</h4>
            <p className="text-sm font-Regular">
              نقش فروشگاه مزرعه در معاملات:
            </p>
            <p className="text-sm font-Regular">
              فروشگاه مزرعه هیچ سودی در قبال خرید و فروش اجناس و خدمات شما
              نمی‌برد به همین خاطر مسولیتی در قبالشان نخواهد داشت.
            </p>
            <p className="text-sm font-Regular">
              پیگیری موارد گزارش شده و انتقال به مقام‌های قضایی بابت پیگیری.
            </p>
            <p className="text-sm font-Regular">
              فرشگاه مزرعه هیچ گونه نقشی در قیمت گذاری محصولاتی که ارایه می شود
              ندارد و مستقیما از سمت فروشندگان و ارایه دهندگان خدمات این امر
              انجام می گیرد.
            </p>
            <h4 className="text-md font-Medium">آگهی‌های من:</h4>
            <p className="text-sm font-Regular">
              در این بخش می توانید تمامی آگهی‌هایی که در فروشگاه مزرعه ثبت کردید
              را مشاهده کنید و اگر نیاز به تغییرات و حذف داشته باشید از این بخش
              اقدام کنید
            </p>
            <h4 className="text-md font-Medium">نظرات و گزارشات:</h4>
            <p className="text-sm font-Regular">
              در این بخش جواب نطراتی که در رابطه با خریدهای قبلی داشتید و همین
              طور پاسخ آزمایشاتی که درخواست دادید را می‌توانید مشاهده کنید.
            </p>
            <h4 className="text-md font-Medium">آگهی‌های نشان شده:</h4>
            <p className="text-sm font-Regular">
              اگر کارت آگهی را مشاهده کردید و خواستید بعدا سریعا به آن دسترسی
              داشته باشید می توانید با استفاده از علامت تعیین شده در کارت‌های
              آگهی آن را نشانه گذاری کنید و در بخش آگهی‌های نشان شده مشاهده
              کنید.
            </p>
            <p className="text-sm font-Regular" title="فروشندگان: ">
              در این صفحه شما می‌تونید با انتخاب دسته‌بندی مورد نظرتان در صفحه‌ی
              اول سامانه آگهی‌های فروش که از سمت فروشنگان ثبت شده است را مشاهده
              کنید و از ابزارهای جستجو و فیلتر کردن آگهی‌ها استفاده کنید.
            </p>
            <p className="text-sm font-Regular" title="خریداران: ">
              در این بخش کشاورزانی که در سامانه اصلی مزرعه نیازهای خود را ثبت
              کرده‌اند را می‌توانید مشاهده کنید و درصورتی که کالا یا خدمات لازم
              برای رفع آن نیاز را داشته باشید مستقیما با کشاورز تماس بگیرید و
              کالا یا خدمات را ارایه دهید.
            </p>
            <p className="text-sm font-Regular" title="ثبت آگهی: ">
              در این بخش شما می‌توانید نسبت به فعالیت و خدماتی که دارید با
              انتخاب دسته‌بندی مناسب آگهی فروش کالا یا ارایه خدمات ثبت کنید تا
              کشاورزان یا دیگر اشخاصی که به آن کالا یا خدمت نیاز دارند با شما
              ارتباط برقرار کنند.
            </p>
            <p className="text-sm font-Regular" title="پیام‌ها: ">
              در این صفحه شما می‌توانید تمامی پیام‌هایی که با افراد و فروشگاه‌ها
              مختلف داشته‌اید را مشاهده کنید و همین طور اگر شخصی در رابطه با
              آگهی کالا یا خدمات شما پرسشی داشته را پاسخ دهید.
            </p>
            <h4 className="text-md font-Medium">سوالات تخصصی:</h4>
            <p className="text-sm font-Regular">
              چه مدت زمانی بعد از درخواست ثبت آگهی کارت آگهی من منتشر خواهد شد؟
            </p>
            <p className="text-sm font-Regular">
              بعد از ثبت درخواست شما کارشناسان ما محتوای آگهی شما را برسی خواهند
              کرد و اگر مغایرتی با قوانین و مقررات سامانه مزرعه نداشته باشد بین
              یک تا ده ساعت آینده منتشر خواهد شد.
            </p>
            <p className="text-sm font-Regular">
              در چه صورتی آگهی من رد شده اعلام می‌شود؟
            </p>
            <p className="text-sm font-Regular">
              پس از برسی کارشناسان‌ ما در بخش‌های مختلف آگهی اعم از عکس، تیتر،
              توضیحات و... اگر مغایرتی با قوانین و مقررات سامانه داشته باشد آگهی
              شما رد شده اعلام می‌شود و در قسمت آگهی‌های من با عنوان تیتر رد شده
              مشاهده خواهید کرد.
            </p>
            <p className="text-sm font-Regular">
              انتشار هرگونه آگهی که خارج از قلمرو سرزمینی ایران باشد.
            </p>
            <p className="text-sm font-Regular">
              انتشار هرگونه آگهی که موضوع و محتوا و تصویر آن شامل چیزی‌ باشد که
              نگهداری و خرید و فروش آن در قلمرو سرزمینی ایران غیرقانونی است.
            </p>
            <p className="text-sm font-Regular">
              انتشار هرگونه آگهی که موضوع و محتوا و تصویر آن در لیست کالاها و
              فعالیت‌های ممنوعه قرار دارد.
            </p>
            <p className="text-sm font-Regular">انتشار آگهی تکراری</p>
            <p className="text-sm font-Regular">
              انتشار هرگونه آگهی‌ که شامل عباراتی غیرمرتبط با موضوع آگهی باشد.
            </p>
            <p className="text-sm font-Regular">
              انتشار هرگونه آگهی که مضمون آن مستهجن و مبتذل و نامتعارف یا بر
              خلاف قوانین کشور باشد.
            </p>
            <p className="text-sm font-Regular">
              انتشار هرگونه آگهی که شامل توهین‌ و نشر اکاذیب و افترا باشد و
              محتوای آن منجر به نقض حقوق مادی و معنوی شخص ثالث یا تعرض به اموال
              و دارایی او شود.
            </p>
            <p className="text-sm font-Regular">
              انتشار هرگونه آگهی که حاوی خبرپراکنی سیاسی و اجتماعی و مذهبی یا
              عقاید شخصی و دعوت به تظاهرات و کمپین‌ها باشد.
            </p>
            <p className="text-sm font-Regular">
              انتشار هرگونه آگهی در دسته‌بندی نادرست
            </p>
            <p className="text-sm font-Regular">
              انتشار هرگونه آگهی با عنوان و محتوای نادرست و مبهم و گمراه‌کننده
            </p>
            <p className="text-sm font-Regular">
              انتشار هرگونه آگهی که مخل آرامش جامعه یا مغایر با ارزش‌های مزرعه
              باشد.
            </p>
            <p className="text-sm font-Regular">
              انتشار هرگونه آگهی که ناقض حقوق مالکیت فکری مزرعه یا اشخاص ثالث
              باشد.
            </p>
            <p className="text-sm font-Regular">
              انتشار هرگونه آگهی که موضوع و محتوای آن به تشخیص نهادهای تخصصی
              موقتاً دارای محدودیت یا ممنوعیت باشد.
            </p>
            <p className="text-sm font-Regular">
              انتشار هرگونه آگهی که منجر به نفرت‌پراکنی یا بی‌احترامی به
              گروه‌های قومی و مذهبی و جنسیتی شود.
            </p>
            <p className="text-sm font-Regular">
              انتشار هرگونه محتوایی که حقوق زنان، کودکان، سالمندان، مهاجران
              خارجی یا موارد مشابه را نقض کند.
            </p>
            <h4 className="text-md font-Medium">
              آیا بابت انتشار آگهی در فروشگاه مزرعه باید هزینه‌ای پرداخت کنم؟
            </h4>
            <p className="text-sm font-Regular">
              خیر انتشار آگهی در فروشگاه مزرعه کاملا رایگان است ولی شما
              می‌توانید از پکیج‌های غیررایگان مختلف برای بهتر دیده شدن آگهی تان
              برای فروش بیشتر استفاده کنید.
            </p>
            <h4 className="text-md font-Medium">
              انتشار آگهی در فروشگاه مزرعه چه مزیتی برای فروشگاه من دارد؟
            </h4>
            <p className="text-sm font-Regular">
              وجه تمایز و برتری فروشگاه مزرعه در این است که با سامانه مزرعه که
              پلتفرم اختصاصی کشاورزان است ارتباط دوسویه دارد و شما به طور مستقیم
              با جامعه تخصصی بزرگی از کشاورزان مرتبط می‌شوید. از طرفی هم خود
              کشاورزان نیازمندی‌های خود را در این سامانه منتشر می‌کنند و شما می
              توانید مستقیما با کشاورزان در ارتباط باشید تا نیازهای ایشان را
              تامین کنید.
            </p>
          </p>
        </div>
      </div>{' '}
      <MainFooter />
    </div>
  );
};

export default Rules;
